<div mat-dialog-content class="alert-ok" *ngIf="!title">
  <p class="message" [innerHTML]="message"></p>
</div>
<div mat-dialog-content class="alert-ok-title" *ngIf="title">
  <p class="title" [innerHTML]="title"></p>
  <p class="message" [innerHTML]="message"></p>
  <p class="subMessage" [innerHTML]="subMessage"></p>
</div>
<div mat-dialog-actions class="box-button-ok">
  <button mat-button class="cancel" (click)="cancel()" *ngIf="cancel" [innerHTML]="'BUTTON.CANCEL' | t">
    CANCEL
  </button>
  <button mat-button (click)="close(true)" [innerHTML]="'BUTTON.OK' | t">OK</button>
</div>
